import { createAPIActions } from '../../utils/redux-actions';

export const alerts = createAPIActions('ALERTS');
export const notifications = createAPIActions('NOTIFICATIONS');
export const notificationsUnreadCount = createAPIActions('NOTIFICATIONS_UNREAD_COUNT');
